import { CompanyData } from '../../types/CompanyData';
import { AccountSourceId } from '../../types/AccountSources';

export enum AccountLoginSecurityEvents {
  AUTHENTICATION_METHOD_CHANGED = 'authenticationMethodChanged',
  TWO_FA_RESET = '2FAReset',
}

export interface AccountLoginSecurityData {
  _id?: string;
  twoFactorAuthentication?: {
    enabled: boolean;
  };
  passwordLifetime?: number;
  accountLockdown?: {
    enabled: boolean;
    allowance: number;
  };
  concurrentSessions?: {
    enabled: boolean;
  };
  companyInfo: CompanyData;
  source?: AccountSourceId;
}
